import { put, takeEvery } from "redux-saga/effects";
import { createBrowserHistory } from "history";
import {
    FETCH_PAYMENTS_INIT_ACTION,
    FETCH_PAYMENTS_SUCCESS_ACTION,
    FETCH_PAYMENTS_FAIL_ACTION
} from "./action";
import { push } from "connected-react-router";
import { appConfig } from "../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

var history = createBrowserHistory();

function* getPayments(value) {
  const token = localStorage.getItem("token");
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const distID =
    userDetails.role === "employee" ? userDetails.distributor : userDetails.id;

  let pageno = (!(value.value)) ? 1 : (value.value.page === undefined ? 1 : value.value.page);
    let filter = (!(value.value)) ? "" : (value.value.filter==="" ? "" : value.value.filter);
    let search = (!(value.value)) ? "" : (value.value.search==="" ? "" : value.value.search);

  try {
    const res = yield fetch(
      `${appConfig.ip}/payment?recptId=${distID}&search=${search}&status=${filter}&limit=10&page=${pageno}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!res.ok) {
        throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_PAYMENTS_SUCCESS_ACTION,
        payload: resJSON,
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: FETCH_PAYMENTS_FAIL_ACTION,
        error: err,
      });
    } else {
    }
  }
}

export function* PaymentActionWatcher() {
  yield takeEvery(FETCH_PAYMENTS_INIT_ACTION, getPayments);
}
